export const CustomEvents = {
  AJAX_EVENTS: {
    loaded: 'ajax:loaded',
    updated: 'ajax:updated',
  },
  LOADER_EVENTS: {
    show: 'loader:show',
    hide: 'loader:hide',
    showLocal: 'loader:showlocal',
    hideLocal: 'loader:hidelocal',
    visible: 'loader:visible',
    hidden: 'loader:hidden',
  },
  LOAD_COMPONENT: {
    simplebar: 'load:simplebar',
  },
  SCREEN_EVENTS: {
    resize: 'screen:resize',
  },
  KEYBOARD_EVENTS: {
    escape: 'ku:key:escape',
    enter: 'ku:key:enter',
    tab: 'ku:key:tab',
  },
  MQ_EVENTS: {
    xs: {
      in: 'mq.xs.in',
      out: 'mq.xs.out',
      current: 'mq.xs.cur',
    },
    sm: {
      in: 'mq.sm.in',
      out: 'mq.sm.out',
      current: 'mq.sm.cur',
    },
    md: {
      in: 'mq.md.in',
      out: 'mq.md.out',
      current: 'mq.md.cur',
    },
    lg: {
      in: 'mq.lg.in',
      out: 'mq.lg.out',
      current: 'mq.lg.cur',
    },
    xl: {
      in: 'mq.xl.in',
      out: 'mq.xl.out',
      current: 'mq.xl.cur',
    },
  },
  SEARCH_LAYER_EVENTS: {
    click: 'search.layer:click',
    show: 'search.layer:show',
    hide: 'search.layer:hide',
    open: 'search.layer:open',
    close: 'search.layer:closed',
  },
  BENEFIT_BAR_EVENTS: {
    show: 'benefit.bar:show',
    hide: 'benefit.bar:hide',
    hideByScroll: 'benefit.bar:hide-by-scroll',
  },
  BACKDROP_EVENTS: {
    show: 'backdrop:show',
    hide: 'backdrop:hide',
    close: 'backdrop:close',
    hidden: 'backdrop:hidden',
    shown: 'backdrop:shown',
  },
  PRODUCT_EVENTS: {
    addtocart: 'product:addtocart',
    addedtocart: 'product:addedtocart',
    sizerequired: 'product:sizerequired',
    sizechanged: 'product:sizechanged',
    notifyme: 'product:notifyme',
    notifymeclose: 'product:notifymeclose',
    notifymesuccess: 'product:notifymesuccess',
    notifymereset: 'product:notifymereset',
    addtowish: 'product:addtowish',
    addedtowish: 'product:addetowish',
    removefromwish: 'product:removefromwish',
    removedfromwish: 'product:removedfromwish',
    sizechangedwish: 'product:sizechangedwish',
  },
  MASONRY_GALLERY_EVENTS: {
    update: 'masonry-gallery:update',
  },
  SIZES_EVENTS: {
    sizesopen: 'sizes:open',
    sizesclose: 'sizes:close',
    sizestoggle: 'sizes:toggle',
  },
  MINICART_EVENTS: {
    open: 'minicart:open',
    updateqty: 'minicart:updateqty',
    update: 'minicart:update',
    close: 'minicart:close',
  },
  MINIWISHLIST_EVENTS: {
    open: 'miniwishlist:open',
    updateqty: 'miniwishlist:updateqty',
    update: 'miniwishlist:update',
    close: 'miniwishlist:close',
    removed: 'miniwishlist:removed',
  },
  MODAL_EVENTS: {
    show: 'modal:show',
    hide: 'modal:hide',
    shown: 'modal:shown',
    hidden: 'modal:hidden',
    afterOpen: 'modal:afterOpen',
    afterClose: 'modal:afterClose',
    afterUpdateContent: 'modal:afterUpdate',
    egonValidation: 'modal:egonValidation',
  },
  SORT_BY_EVENTS: {
    changed: 'sortBy:changed',
    close: 'sortBy:close',
  },
  FILTERS_EVENTS: {
    updated: 'query:updated',
    pageLoaded: 'ajaxPage:loaded',
    active: 'filters:active',
    closeItems: 'close:filteritems',
  },
  RECOMMENDATION_ENGINE_EVENTS: {
    updated: 'recommendationWishlist:updated',
    updatedGoogle: 'recommendationWishlist:updatedGoogle',
  },
  PAGE_LAYOUT_EVENTS: {
    changed: 'pageLayout',
  },
  LISTING_LAYOUT_EVENTS: {
    changed: 'listingLayout',
  },
  HEADER_EVENTS: {
    enableTransparent: 'transparent:enable',
    disableTransparent: 'transparent:disable',
    showSubmenu: 'submenu:show',
  },
  INFINITE_SCROLL_EVENTS: {
    next: 'infiniteScroll:next',
    loaded: 'infiniteScroll:loaded',
    animation: 'infiniteScroll:animation',
    viewAll: 'infiniteScroll:viewAll',
    hide: 'infiniteScroll:hide',
    reset: 'infiniteScroll:reset'
  },
  PAGINATION_EVENTS: {
    prev: 'pagination:prev',
    next: 'pagination:next',
    goTo: 'pagination:goTo'
  },
  PAGE_EVENTS: {
    prev: 'page:prev',
    next: 'page:next'
  },
  COOKIE: {
    accepted: 'cookie:accepted',
  },
  RETURN_EVENTS: {
    subsituteProduct: 'product:substituted',
  },
  CAROUSEL: {
    triggerCarousel: 'carousel:trigger',
    initCarousel: 'carousel:init',

  },
  MENU_EVENTS: {
    showMenu: 'menu:show',
    hideMenu: 'menu:hide',
    active: 'menu:active',
    inactive: 'menu:inactive',
  },
  CHECKOUT_EVENTS: {
    showInvoiceBox: 'invoice:show',
    showInvoiceFormLabels: 'invoiceLabels:show',
    hideInvoiceBox: 'invoice:hide',
    showShippingForm: 'shipping:show',
    hideShippingForm: 'shipping:hide',
    paymentSelected: 'payment:selected',
    privacyChange: 'privacy:change',
    selectShippingAddress: 'shipping:select',
    selectBillingAddress: 'billing:select',
    fastSelectShippingAddress: 'shipping:selectFast',
    fastSelectBillingAddress: 'billing:selectFast'
  },
  SHIPMENT_EVENTS: {
    valid: 'checkout:proceed',
    invalid: 'checkout:stop',
  },
  PAYMENTS_EVENTS: {
    paypal: 'paypal:token',
    standardPaymentMethodSelected: 'payments:standardPaymentMethodSelected',
    adyenPaymentMethodSelected: 'payments:adyenPaymentMethodSelected',
    adyenButtonSubmit: "payments:adyenbuttonSubmit",
    paypalStandardSubmit: "paypal:standardSubmit",
    applepaySubmit: "applepay:standardSubmit"
  },
  CHANGE_AVAILABLE_LAYER: {
    available: 'availableChange:true',
  },
  CHANGE_RETURN_STEPS: {
    enableConfirm: 'confirmBtn:enabled',
    disabledConfirm: 'confirmBtn:disabled',
  },
  SIZE_GUIDE: {
    openLayer: 'sizeguide:open',
    closeLayer: 'sizeguide:close',
  },
  NOTIFY_ME_STATE: {
    sent: 'notifyme:sent',
  },
  TRACKING: {
    loadMore: 'track:loadMore',
  },
  O2O: {
    ccManualSearch: 'StoreLocator:Search:Place',
    ccStoreSelect: 'StoreLocator:Store:Select',
    ccStoresShowResults: 'StoreLocator:Stores:ShowResults',
  },
  VALIDATION: {
    bindValidation: 'validation:bind',
  },
  PDP_LAYER_EVENTS: {
    open: 'pdpLayer:open',
    close: 'pdpLayer:close',
    openZoom: 'pdpLayer:openZoom',
    closeZoom: 'pdpLayer:closeZoom',
    closeZoomMobile: 'pdpLayer:closeZoom:mobile',
    triggerCloseZoom: 'pdpLayer:closeZoom:trigger'
  },
  MY_PROFILE_EVENTS: {
    changedPassword: 'myProfile:password:changed'
  },
  NL_MODULE_EVENTS: {
    error: 'nlModule:error',
    show: 'nlModule:show',
    hide: 'nlModule:hide',
    shown: 'nlModule:shown',
    hidden: 'nlModule:hidden',
    afterOpen: 'nlModule:afterOpen',
    afterClose: 'nlModule:afterClose',
    subscribed: 'nlModule:subscribed',
  },
  NL_POPUP_EVENTS: {
    error: 'nlPop:error',
    show: 'nlPop:show',
    hide: 'nlPop:hide',
    shown: 'nlPop:shown',
    hidden: 'nlPop:hidden',
    afterOpen: 'nlPop:afterOpen',
    afterClose: 'nlPop:afterClose',
    subscribed: 'nlPop:subscribed',
  },
  LOGIN_POPUP_EVENTS: {
    error: 'loginPop:error',
    show: 'loginPop:show',
    hide: 'loginPop:hide',
    shown: 'loginPop:shown',
    hidden: 'loginPop:hidden',
    afterOpen: 'loginPop:afterOpen',
    afterClose: 'loginPop:afterClose',
    subscribed: 'loginPop:subscribed',
    showFloatingIcon: 'loginPop:showFloatingIcon',
    hideFloatingIcon: 'loginPop:hideFloatingIcon'
  },
  NL_FOOTER_EVENTS: {
    error: 'nlPop:error',
    show: 'nlPop:show',
    hide: 'nlPop:hide',
    shown: 'nlPop:shown',
    hidden: 'nlPop:hidden',
    afterOpen: 'nlPop:afterOpen',
    afterClose: 'nlPop:afterClose',
    subscribed: 'nlPop:subscribed',
  },
  COM_POPUP_EVENTS: {
    show: 'comPop:show',
    hide: 'comPop:hide',
    shown: 'comPop:shown',
    hidden: 'comPop:hidden',
    afterOpen: 'comPop:afterOpen',
    afterClose: 'comPop:afterClose',
  },
  COLLAPSE_EVENTS: {
    update: 'collapse:update',
    toggle: 'collapse:toggle',
  },
  ACCOUNT_EVENTS: {
    pwdResetForm: 'resetForm:show',
    addressLabels: 'labels:show',
  },
  TOOLTIP_EVENTS: {
    create: 'createTooltip:create',
    destroy: 'destroyTooltip:destroy',
  },
  SIMPLEBAR_EVENTS: {
    loaded: 'simpleBar:loaded',
  },
  YEXT_EVENTS: {
    faqsLoaded: 'faqs:loaded',
  },
  TRIGGERED_LABEL_EVENTS: {
    set: 'triggeredlabel:set',
    trigger: 'triggeredlabel:trigger'
  },
  SELECT_EVENTS: {
    change: 'select2:change'
  }
};
